// removed by extract-text-webpack-plugin
module.exports = {"modal":"MainView__modal","modalContent":"MainView__modalContent","canvas-content-style-bundles":"MainView__canvas-content-style-bundles","canvasContentStyleBundles":"MainView__canvas-content-style-bundles","infinite-loader-wrapper":"MainView__infinite-loader-wrapper","infiniteLoaderWrapper":"MainView__infinite-loader-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/MainView/MainView.container.scss
// module id = 1419
// module chunks = 8